import { authRoutePaths } from './paths';

import type { RouteObject } from 'react-router-dom';

export const authRoute: RouteObject[] = [
  {
    path: authRoutePaths.login.path,
    async lazy() {
      const LoginPage = await import('@/pages/auth/Login');
      return { Component: LoginPage.default };
    },
  },
  {
    path: authRoutePaths.signUp.path,
    async lazy() {
      const SignUpPage = await import('@/pages/auth/SignUp');
      return { Component: SignUpPage.default };
    },
  },
  {
    path: authRoutePaths.resetPassword.path,
    async lazy() {
      const ResetPasswordPage = await import('@/pages/auth/ResetPassword');
      return { Component: ResetPasswordPage.default };
    },
  },
  // TRAD-2249 — `terms`(약관 전문)는 여기가 아니라 policyRoute(MainLayout)에 있다.
  // 푸터·고객지원에서 링크되는 정책 문서인데 인증 그룹에 있어서, 들어가면 푸터가 사라졌다.
  // `terms-agreement`(동의 제출 플로우)는 **별개 컴포넌트**이고 PrivateRoute 가 미동의 시
  // 강제 이동시키는 게이트라 인증 그룹에 그대로 남는다 — 여기에 푸터가 뜨면 그것도 사고다.
  {
    path: authRoutePaths.termsAgreement.path,
    async lazy() {
      const TermsAgreementPage = await import('@/pages/auth/TermsAgreement');
      return { Component: TermsAgreementPage.default };
    },
  },
  // TRAD-3790 — MainLayout 밖(헤더·푸터 없음). 쿼리는 main.tsx 첫 import 에서 이미 지워져 있다.
  {
    path: authRoutePaths.appleAndroidCallback.path,
    async lazy() {
      const AppleAndroidCallbackPage = await import('@/pages/auth/AppleAndroidCallback');
      return { Component: AppleAndroidCallbackPage.default };
    },
  },
];
